<template>
  <div class="ec-list">
    <div class="ec-list__item" v-for="item in data" :key="item.orgId">
      <div class="ec-list__order">{{item.order}}</div>
      <div class="ec-list__name">{{item.name}}</div>
      <div class="ec-list__num">{{item.num}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EcList',
  props: {
    data: {
      type: [Array, Object],
      default: () => {
        return  []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ec-list {
  font-size: 0;
  &__item {
    color: #fff;
    padding: 2px 8px;
    &:first-child {
      padding-top: 2px;
    }
    &:nth-child(2n+1) {
      background: rgba(0, 0, 0, 0.1)
    }
    &:nth-child(2n) {
      background: rgba(255, 255, 255, 0.06)
    }
  }
  &__order {
    width: 16%;
  }
  &__name {
    width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all;
  }
  &__num {
    width: 24%;
    text-align: center;
  }
  &__order,
  &__name,
  &__num {
    display: inline-block;
    vertical-align: middle;
    font-size: 10px;
    .ec-list__item:first-child & {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataIndex/components/EcList.vue